<template>
  <div v-if="locked && !isDev">
    <UnderConstruction
      :title="'Under Construction'"
      :back-button="'back'"
      :show-button="'show'"
      :hide-button="'hide'"
      :show-loader="true"
      :total-digits="4"
      :redirect-url="'/'"
    />
  </div>

  <div v-else>
    <VideoSplash v-if="isVideoSplash">
      <RouterView />
    </VideoSplash>

    <VideoTube v-else>
      <RouterView />
    </VideoTube>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify';

export default {
  components: {
    VideoTube: () => import('@/apps/VideoTube'),
    VideoSplash: () => import('@/apps/VideoSplash'),
    UnderConstruction: () => import('@/components/UnderConstruction'),
  },

  computed: {
    ...sync([
      'site.locked', //
    ]),

    isDev() {
      return process.env.NODE_ENV === 'development';
    },

    isVideoSplash() {
      return window.location.pathname.includes('/splash');
    },
  },

  mounted() {
    // Disable logging if not on dev
    if (process.env.NODE_ENV === 'development') {
      console.log(`ENV => ${process.env.NODE_ENV} - console messages are shown!`);
    } else {
      console.log = () => {};
    }
  },
};
</script>
